import React, { useState } from 'react';
import Pagination from '../Pagination/Pagination';

function Table({ collectionData, currentPage, totalPages, onPageChange, selectedCollectionId, setSelectedCollectionId }) {


    // return
    const handleSelect = (collectionId) => {
        if (selectedCollectionId === collectionId) {
            setSelectedCollectionId(''); // Unselect if already selected
        } else {
            setSelectedCollectionId(collectionId); // Select new collection
        }
    };

    return (
        <div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Id</th>
                            <th scope="col" className="px-6 py-3">Collection Name</th>
                            <th scope="col" className="px-6 py-3">Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        {collectionData?.map((item, index) => (
                            <tr
                                key={index}
                                className={`odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 ${selectedCollectionId === item.eventCollectionId ? 'bg-blue-100' : ''}`}
                            >
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                    {item?.eventCollectionId}
                                </td>
                                <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                    {item?.eventCollectionName}
                                </td>
                                <td className="px-6 py-4">
                                    <button
                                        type='button'
                                        className={`font-bold py-1 px-4 rounded ${selectedCollectionId === item?.eventCollectionId ? 'bg-red-500 hover:bg-red-700 text-white' : 'bg-blue-500 hover:bg-blue-700 text-white'}`}
                                        onClick={() => handleSelect(item?.eventCollectionId)}
                                    >
                                        {selectedCollectionId === item?.eventCollectionId ? 'Unselect' : 'Select'}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
    );
}

export default Table;
